import { createContext, useContext } from 'react';
import RootStore from './store';

const StoreContext = createContext(new RootStore({}));

export default StoreContext;

export const useStore = (): RootStore => useContext(StoreContext);
